// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { variantOptionsListStyles } from "@tps/App/Widgets/ProductDetails/ProductDetailsVariantOptionsList";
import { fontConfig } from "@tps/XDL/PreStyle/typography";
import { css } from "styled-components";

variantOptionsListStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

variantOptionsListStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

variantOptionsListStyles.inquireMessageText = {
    variant: "h3",
    as: "p",
    css: css`
        ${StyledButton} > ${TypographyStyle} {
            font-size: ${fontConfig.headLine.size}px;
            line-height: ${fontConfig.headLine.lineHeight};
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};
